import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const WorkflowSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default WorkflowSVG;
